export const BlogItems = [
  {
    foodImg:
      'https://images.unsplash.com/photo-1604382355076-af4b0eb60143?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pizza1',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1599749011927-9a77278bfa61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1888&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pasta2',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1608219994488-cc269412b3e4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Fries3',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1604382355076-af4b0eb60143?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pizza4',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1599749011927-9a77278bfa61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1888&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pasta5',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1608219994488-cc269412b3e4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Fries6',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1604382355076-af4b0eb60143?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pizza7',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1599749011927-9a77278bfa61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1888&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pasta8',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1608219994488-cc269412b3e4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Fries9',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1604382355076-af4b0eb60143?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pizza10',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1599749011927-9a77278bfa61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1888&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pasta11',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1608219994488-cc269412b3e4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Fries12',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1604382355076-af4b0eb60143?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pizza13',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1599749011927-9a77278bfa61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1888&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pasta14',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1608219994488-cc269412b3e4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Fries15',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1604382355076-af4b0eb60143?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pizza16',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1599749011927-9a77278bfa61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1888&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pasta17',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1608219994488-cc269412b3e4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Fries18',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1604382355076-af4b0eb60143?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pizza19',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1599749011927-9a77278bfa61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1888&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pasta20',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1608219994488-cc269412b3e4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Fries21',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1604382355076-af4b0eb60143?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pizza22',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1599749011927-9a77278bfa61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1888&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Pasta23',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
  {
    foodImg:
      'https://images.unsplash.com/photo-1608219994488-cc269412b3e4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    date: 'Sept 10, 2019',
    author: 'Admin',
    comment: '3',
    title: 'The Delicious Fries24',
    text: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.',
  },
];
